var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesktopAppliationDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 4.5,
    stroke: "#DC2418"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 41.25H39.25C39.9501 41.25 40.3001 41.25 40.5675 41.1138C40.8028 40.9939 40.9939 40.8028 41.1138 40.5675C41.25 40.3001 41.25 39.9501 41.25 39.25V20.75C41.25 20.0499 41.25 19.6999 41.1138 19.4325C40.9939 19.1973 40.8028 19.0061 40.5675 18.8862C40.3001 18.75 39.9501 18.75 39.25 18.75H32C31.2999 18.75 30.9499 18.75 30.6825 18.8862C30.4472 19.0061 30.2561 19.1973 30.1363 19.4325C30 19.6999 30 20.0499 30 20.75V22.5M27.5 37.5V41.25M23.75 41.25H31.25M22.75 37.5H32.25C33.6501 37.5 34.3502 37.5 34.885 37.2275C35.3554 36.9879 35.7379 36.6054 35.9775 36.135C36.25 35.6003 36.25 34.9001 36.25 33.5V26.5C36.25 25.0999 36.25 24.3998 35.9775 23.865C35.7379 23.3946 35.3554 23.0122 34.885 22.7725C34.3502 22.5 33.6501 22.5 32.25 22.5H22.75C21.3499 22.5 20.6498 22.5 20.115 22.7725C19.6446 23.0122 19.2622 23.3946 19.0225 23.865C18.75 24.3998 18.75 25.0999 18.75 26.5V33.5C18.75 34.9001 18.75 35.6003 19.0225 36.135C19.2622 36.6054 19.6446 36.9879 20.115 37.2275C20.6498 37.5 21.3499 37.5 22.75 37.5Z",
    stroke: "#DC2418",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopAppliationDeveloper);
export default __webpack_public_path__ + "static/media/desktopAppliationDeveloper.31570d760f99901183f6ff0bc5952053.svg";
export { ForwardRef as ReactComponent };